import { httpClient } from './httpClient';

export interface PageEvent {
  eventId: string;
  headline: string;
  summary: string;
  eventType: string;
  significance: string;
  eventDate: string;
  contextText: string;
}

export interface PageContextResponse {
  documentId: string;
  pageNumber: number;
  events: PageEvent[];
}

export interface PageEventMapResponse {
  documentId: string;
  pageEventCounts: Record<number, number>;
}

export interface PageThemesResponse {
  documentId: string;
  pageThemes: Record<number, string[]>;
}

export const pageContextApi = {
  getPageContext: (documentId: string, pageNumber: number): Promise<PageContextResponse> =>
    httpClient.get<PageContextResponse>('/intelligence/page-context', { documentId, pageNumber }),

  getPageEventMap: (documentId: string): Promise<PageEventMapResponse> =>
    httpClient.get<PageEventMapResponse>('/intelligence/page-event-map', { documentId }),

  getPageThemes: (documentId: string): Promise<PageThemesResponse> =>
    httpClient.get<PageThemesResponse>('/intelligence/page-themes', { documentId }),
};
